import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowDownLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowDownLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M17.75 4.48218L7.5 14.7322V7.99994H5V18.9999H16V16.4999H9.26777L19.5178 6.24994L17.75 4.48218Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowDownLeft;
